import Validator from './Validator';

export default function validateUpdateCompanyUserSignature(form) {
  return Validator.create(form, {});
}
